import { CREATE_ACCOUNT_REQUEST, CREATE_ACCOUNT_SUCCESS } from './createAccount';
import { createSelector } from 'reselect';
import { DISMISS_MODAL } from './actions';
import { GlobalState } from '../rootReducer';
import { LOGIN_SUCCESS } from './login';

/* Action Types */
export const BIDDER_EXISTS_SUCCESS = 'la/ui/bidderExists/SUCCESS';

// reducer
const DEFAULT_STATE = {
    email: '',
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case BIDDER_EXISTS_SUCCESS:
            return {
                ...state,
                email: action.payload.email,
            };
        case CREATE_ACCOUNT_REQUEST:
        case CREATE_ACCOUNT_SUCCESS:
        case DISMISS_MODAL:
        case LOGIN_SUCCESS:
            return {
                ...state,
                email: '',
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.bidderExists;

const getUiBidderExists = createSelector(stateSelector, (state) => state);

export const getBidderExists = createSelector(getUiBidderExists, (state) => Boolean(state.email));

export const getBidderExistsEmail = createSelector(getUiBidderExists, (state) => state.email);

/* ACTION CREATORS */
export const bidderExistsSuccess = (email: string) => ({
    payload: { email },
    type: BIDDER_EXISTS_SUCCESS,
});
